import { render, staticRenderFns } from "./PaymentRequisitionActivityDialog.vue?vue&type=template&id=3282ad26&"
import script from "./PaymentRequisitionActivityDialog.vue?vue&type=script&lang=ts&"
export * from "./PaymentRequisitionActivityDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports